export const exerciseCardFeatures = [
  'Nombre del ejercicio (claro, en castellano)',
  'Objetivo: qué trabaja y para qué',
  'Indicación para la profesora: cómo explicarlo sin complicaciones',
  'Cues técnicos: las frases exactas que funcionan',
  'Errores frecuentes: qué NO hacer',
  'Correcciones: cómo fijar lo malo',
  'Imagen de referencia profesional',
  'Variantes (progresión y regresión)',
  'Adaptaciones por nivel',
  'Notas de seguridad'
];
